import { createTheme } from '@material-ui/core/styles';

export default function tableTheme(title) {
  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MUIDataTable: {
          paper: {
            boxShadow: '0px 1px 5px 0px #cdcfdd',
          },
        },
        MuiIconButton: {
          root: {
            color: 'inherit',
            '&:hover, &:focus': {
              color: '#1e7dff',
            },
            padding: '0px',
            margin: title === 'ACTIVITY' ? '0 2px' : '0 5px',
          },
        },
        MUIDataTableToolbar: {
          icon: {
            '&:hover, &:focus': {
              color: '#1e7dff',
            },
          },
          iconActive: {
            color: '#1e7dff',
          },
          titleRoot: {
            '& h6': {
              color: '#ffffff',
            },
          },
        },
        MUIDataTableSearch: {
          searchIcon: {
            color: '#f1f1f1',
          },
          searchText: {
            '& input': {
              color: title !== 'Locations' ? '#ffffff' : '#181b1e',
            },
          },
        },
        MuiInputBase: {},
        MuiButton: {
          fullWidth: {
            backgroundColor: '#6754ff',
            color: 'white',
          },
        },
        MuiSelect: {
          select: {
            color: '#000000',
          },
        },
        MuiInput: {
          underline: {
            '&:before': {
              borderBottom: '2px solid #f1f1f1',
            },
            '&:after': {
              borderBottom: '2px solid black',
            },
          },
        },
        MUIDataTableResize: {
          resizer: {
            border: 0,
            borderLeft: '2px solid #4b514e',
            height: '56px',
          },
        },
        MuiCheckbox: {
          colorSecondary: {
            color: '#4b514e !important',
            '&$checked': {
              color: '#1e7dff !important',
            },
          },
          colorPrimary: {
            color: '#4b514e !important',
            '&$checked': {
              color: '#1e7dff !important',
            },
          },
        },
        MuiToolbar: {
          root: {
            backgroundColor: '#6754ff',
            fontWeight: 'bold',
            color: '#ffffff',
            borderTopLeftRadius: '5px',
            borderTopRightRadius: '5px',
          },
          regular: {
            minHeight: title === 'ACTIVITY' ? '30px!important' : 'unset',
          },
        },
        MuiTableHead: {
          root: {
            background: '#6754FF',
          },
        },
        MuiTableCell: {
          body: {
            color: '#181b1e',
          },
          root: {
            fontSize: 13,
            padding: '4px 16px',
            whiteSpace: 'nowrap',
          },
          footer: {
            padding: '7px 14px',
            background: '#ececec',
          },
        },
        MUIDataTableSelectCell: {
          headerCell: {
            backgroundColor: '#6754ff',
            fontWeight: 'bold',
            color: '#ffffff',
          },
        },
        MuiTableRow: {
          root: {
            '&$selected': {
              backgroundColor: '#ebf0ef',
              '&:hover, &:focus': {
                backgroundColor: '#f2f2f2',
              },
            },
          },
        },
        MUIDataTableHeadCell: {
          fixedHeader: {
            backgroundColor: '#6754ff',
            fontWeight: 'bold',
            color: '#ffffff',
            padding: '10px 16px',
            whiteSpace: 'nowrap',
            // borderRight: '1px solid grey !important',
          },
          sortActive: {
            color: '#1e7dff',
          },
          sortAction: {
            '& svg': {
              fill: '#1e7dff', // or whatever you need
            },
          },
        },
        MuiTypography: {
          h6: {
            textTransform: 'uppercase',
            fontWeight: 'bold',
          },
        },
        MUIDataTablePagination: {
          toolbar: {
            backgroundColor: '#ffffff',
            color: '#555555',
            padding: title === 'ACTIVITY' ? 5 : 15,
          },
          navContainer: {
            backgroundColor: '#ffffff',
          },
          tableCellContainer: {
            padding: 0,
          },
        },
        PrivateSwitchBase: {
          root: {
            padding: 3,
          },
        },
        MUIDataTableFilterList: {
          root: {
            margin: 0,
            padding: '0px 16px 6px 16px',
            backgroundColor: '#6754FF',
          },
        },
        MuiChip: {
          root: {
            backgroundColor: '#2f2f2f',
            opacity: 0.9,
            color: '#f1f1f1',
          },
          deleteIcon: {
            color: '#181b1e',
            '&:hover, &:focus': {
              color: 'rgb(238, 63, 63)',
            },
          },
        },
        MuiSvgIcon: {
          root: {
            width: '.9em',
            height: '.9em',
          },
        },
      },
    });

  return getMuiTheme;
}
